export const DEFAULT_HEADER_COLOR = '#2585F6';



// WEBPACK FOOTER //
// ./node_modules/shared-web/src/components/widget/Header/constants.js